import React from "react";
import { LanguageTableProps, LanguageTableState } from "./models";


import { Box, IconButton, Stack } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';

import MaterialReactTable from 'material-react-table';
import type { MRT_ColumnDef } from 'material-react-table';

import EditIcon from "@mui/icons-material/Edit";

import { t } from "@lingui/macro";

import { Language } from "models";
import { ConfirmModal } from "commons/modal/confirm-modal";


export class LanguageTable extends React.Component<LanguageTableProps, LanguageTableState>
{
    private tableColumns: MRT_ColumnDef[];

    public constructor(props: any) {

        super(props)

        this.state={
            openConfirmModal: false,
            languageToDelete: ""
        }

        this.tableColumns = [
            {
                header: t({
                    id: "lt-table-col-name",
                    message: "Lingua"
                }),
                accessorKey: "value",
                Cell: ({ cell }) => {
                    return (
                        <Box>
                            {cell.getValue<string>()}
                        </Box>
                    );
                },
            },
            {
                header: t({
                    id: "lt-table-col-eng-name",
                    message: "Nome inglese"
                }),
                accessorKey: "engName",
                Cell: ({ cell }) => {
                    return (
                        <Box>
                            {cell.getValue<string>()}
                        </Box>
                    );
                },
            },
            {
                header: t({
                    id: "lt-table-col-iso-code",
                    message: "Codice ISO 639-1"
                }),
                accessorKey: "isoCode",
                Cell: ({ cell }) => {
                    return (
                        <Box>
                            {cell.getValue<string>()}
                        </Box>
                    );
                },
            },
        ];
    }


    private openConfirmModal = (id: string) : void =>{
        this.setState(() => ({
            openConfirmModal: true,
            languageToDelete: id
        }))
    }

    private cancelConfirmModalCallback = () : void =>{
        this.setState(() => ({
            openConfirmModal: false,
            languageToDelete: ""
        }))
    }

    private acceptConfirmModal = () : void =>{
        this.setState(() => ({
            openConfirmModal: false,
        }))
        this.deleteLanguage()
    }

    private deleteLanguage = (): void => {
        this.props.deleteLanguage(this.state.languageToDelete);
        this.setState(() => ({
            languageToDelete: ""
        }))

    }

    private getIdValue = (row: any): string => {
        return row.original.id
    }

    private openEditModal = (language: any) => {
        this.props.openEditLanguageTable(language as Language);
    }

    private handlePageChange = (updateFn: any) => {
        let newPagination = updateFn(this.props.pagination);
        this.props.updatePaginationCallBackFn(newPagination);
    }  

    render() {
        return (
            <>
            <Box style={{ maxWidth: '100%' }}>
                <MaterialReactTable
                    columns={this.tableColumns}
                    rowCount={this.props.totalLanguageCount}
                    pageCount={Math.ceil(this.props.totalLanguageCount / this.props.pagination.pageSize)}
                    data={this.props.languages}
                    enableRowSelection={false}
                    enableColumnOrdering={false}
                    enableColumnActions={false}
                    enableGlobalFilter={false}
                    enableFilters={false}
                    muiTableHeadCellProps={{
                        sx: {
                            color: "white",
                            backgroundColor: process.env.REACT_APP_PRIMARY_COLOR
                        }
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: ""
                        }
                    }}
                    enableRowActions
                    positionActionsColumn="last"
                    renderRowActions={({ row }) => (
                        <Stack direction={"row"} display={"flex"} justifyContent={"right"} >
                            <IconButton onClick={() => this.openEditModal(row.original)}>
                                <EditIcon />
                            </IconButton>
                            <IconButton onClick={() => this.openConfirmModal(this.getIdValue(row))}>
                                <DeleteIcon />
                            </IconButton>
                        </Stack>
                    )}
                    onPaginationChange={this.handlePageChange}
                    enableTopToolbar={false}
                    manualPagination={true}
                    autoResetPageIndex={false}
                    enableDensityToggle={false}
                    state={{
                        pagination: this.props.pagination
                    }} />
            </Box>
            {this.state.openConfirmModal && < ConfirmModal
                cancelConfirmCallback={this.cancelConfirmModalCallback}
                confirmCallback={this.acceptConfirmModal}
                text={"Sei sicuro di voler procedere con l'eliminazione della lingua?"}
                textId={"lt-delete-language-text"}
            />}
    </>)
    }
}
